<template>
  <main id="js-page-content" role="main" class="page-content">
    <ol class="breadcrumb page-breadcrumb">
      <li class="breadcrumb-item">
        <a href="javascript:void(0);">SmartAdmin</a>
      </li>
      <li class="breadcrumb-item">Category</li>
      <li class="breadcrumb-item">Sub-category</li>
      <li class="breadcrumb-item active">Page Title</li>
      <li class="position-absolute pos-top pos-right d-none d-sm-block">
        <span class="js-get-date"></span>
      </li>
    </ol>
    <div class="subheader">
      <h1 class="subheader-title">
        <i class="subheader-icon fal fa-globe"></i> SweetAlert2
        <span class="fw-300">サンプル</span>
        <sup class="badge badge-primary fw-500">STICKER</sup>
        <small> Insert page description or punch line </small>
      </h1>
      <!-- 
		Right content on content header
		A nice area to add graphs or buttons -->
      <div class="subheader-block">Right Subheader Block</div>
    </div>

    <div class="alert alert-primary">
      <div class="d-flex flex-start w-100">
        <div class="mr-2 hidden-md-down">
          <span class="icon-stack icon-stack-lg">
            <i
              class="base base-6 icon-stack-3x opacity-100 color-primary-500"
            ></i>
            <i
              class="base base-10 icon-stack-2x opacity-100 color-primary-300 fa-flip-vertical"
            ></i>
            <i
              class="ni ni-blog-read icon-stack-1x opacity-100 color-white"
            ></i>
          </span>
        </div>
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <span class="h5">注意事項!</span>
            <p>特に注意事項はないです</p>
            <p class="m-0">
              Follow a slogal with a useful link or call to action
              <a href="#" target="_blank">Call to action >></a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div id="panel-x" class="panel">
          <div class="panel-hdr">
            <h2>button</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-close"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Close"
              ></button>
            </div>
          </div>
          <div class="panel-container show">
            <div class="panel-content">
              <div class="frame-wrap">
                <div class="demo">
                  <div class="panel-tag">
                    4種類のダイアログタイプを用意しているので、必要に応じて使い分ける。さらに色々機能はあるので、https://sweetalert2.github.io/を参照。
                  </div>
                  <button
                    @click="showAlert()"
                    type="button"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    通知
                  </button>
                  <button
                    @click="showAlert2()"
                    type="button"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    通知2
                  </button>
                  <button
                    @click="showAlert3()"
                    type="button"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    選択YES or NO
                  </button>
                  <button
                    @click="showAlert4()"
                    type="button"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    インプットボックス
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

@Options({
  components: {
    Swal,
  },
})
export default class Salert extends Vue {
  //参照
  // https://sweetalert2.github.io/
  async showAlert(): Promise<void> {
    Swal.fire("Hello Vue world!!!");
  }
  async showAlert2(): Promise<void> {
    Swal.fire("The Internet?", "That thing is still around?", "warning");
  }
  async showAlert3(): Promise<void> {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: true,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "CANCEL",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          swalWithBootstrapButtons.fire(
            "Deleted!",
            "Your file has been deleted.",
            "success"
          );
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
      });
  }

  async showAlert4(): Promise<void> {
    Swal.fire({
      title: "Submit your Github username",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Look up",
      showLoaderOnConfirm: true,
      preConfirm: (login) => {
        return fetch(`//api.github.com/users/${login}`)
          .then((response) => {
            if (!response.ok) {
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .catch((error) => {
            Swal.showValidationMessage(`Request failed: ${error}`);
          });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: `${result.value.login}'s avatar`,
          imageUrl: result.value.avatar_url,
        });
      }
    });
  }
}
</script>
